export const SET_SELECTED_BRANDS_SUCCESS = 'SET_SELECTED_BRANDS_SUCCESS';
export const SET_SELECTED_BRANDS_FAILURE = 'SET_SELECTED_BRANDS_FAILURE';

export const SET_SELECTED_MANAGER_SUCCESS = 'SET_SELECTED_MANAGER_SUCCESS';
export const SET_SELECTED_MANAGER_FAILURE = 'SET_SELECTED_MANAGER_FAILURE';

export const SET_ORDER_SEARCH_INPUT_SUCCESS = 'SET_ORDER_SEARCH_INPUT_SUCCESS';
export const SET_ORDER_SEARCH_INPUT_FAILURE = 'SET_ORDER_SEARCH_INPUT_FAILURE';
